import { render, staticRenderFns } from "./AddStorageUnit.vue?vue&type=template&id=0f21ac74"
import script from "./AddStorageUnit.vue?vue&type=script&lang=js"
export * from "./AddStorageUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports